var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg_F8F8F8"},[_c('Header',{attrs:{"activeName":_vm.activeName}}),_c('Join',{attrs:{"activeName":_vm.activeName}}),_c('Bottom')],1)}
var staticRenderFns = []

export { render, staticRenderFns }